import { isMigratedCustomPageSlug } from '@shared/utils/migratedCustomPages';
import { useRouteMatch } from '@shared/core';

const WEBSITE = 'website';
const PAGE = 'page';

/**
 * To get current page path/slug
 * @param eventHandle - To get current page path/slug for event
 * @param isAdminPage - To get current page path/slug for admin / guest site
 */
export function useCurrentPageSlug(eventHandle: string, isAdminPage?: boolean) {
  const matchRoute = isAdminPage ? `/${eventHandle}/edit/${WEBSITE}/${PAGE}/:pageSlug` : `/${eventHandle}/${PAGE}/:pageSlug`;

  const routeMatch = useRouteMatch<{ pageSlug: string }>(`/${eventHandle}/:pageSlug`);
  const routeMatchCustomPage = useRouteMatch<{ pageSlug: string }>(matchRoute);

  const isUrlBasedCustomPageSlug = routeMatch?.params.pageSlug === PAGE;
  // Strip query parameters that may leak into the pathname when history.push/replace
  // is called with a URL containing query params as the pathname (e.g., goToPath returns
  // "/event/page?ctx=websiteEditor&..." and callers pass it as { pathname: ... }).
  const rawSlug = isUrlBasedCustomPageSlug ? routeMatchCustomPage?.params.pageSlug : routeMatch?.params.pageSlug;
  const currentPageSlug = rawSlug?.split('?')[0] || undefined;

  // For guest site routes (not admin), a migrated slug is treated as a custom page so routes
  // like /${eventHandle}/story work without requiring /${eventHandle}/page/story.
  const isMigratedSlug = !isAdminPage && isMigratedCustomPageSlug(currentPageSlug);

  const isCustomPageSlug = isUrlBasedCustomPageSlug || isMigratedSlug;

  return { currentPageSlug, isCustomPageSlug, isMigratedSlug, isUrlBasedCustomPageSlug };
}
